import {useSearchParams} from 'react-router';

import {Dashboard} from './dashboard/Dashboard';
import {isCustomizeEnabled} from './dashboard/dashboardFeatureFlags';

export const Home = () => {
  const [searchParams] = useSearchParams();

  return <Dashboard customizeEnabled={isCustomizeEnabled(searchParams)} />;
};
